import React, {useState} from 'react';
import {Popover} from 'antd';
import UserLoggedInUserPopup from './UserLoggedInUserPopup';

const UserLoggedInUser = ({onMenuSelect}) => {
  const [popoverVisible, setPopoverVisible] = useState(false);

  const handlePopoverVisibleChange = (visible) => {
    setPopoverVisible(visible);
  };

  return (
    <div className="w-full">
      <Popover
        content={
          <UserLoggedInUserPopup
            onMenuSelect={onMenuSelect}
            onPopoverVisible={() => setPopoverVisible(false)}
          />
        }
        trigger="click"
        visible={popoverVisible}
        onVisibleChange={handlePopoverVisibleChange}
        placement="bottomLeft"
      >
        <div className="group w-full bg-white rounded-xl border border-gray-200 p-3 cursor-pointer hover:shadow-md transition-all duration-300 hover:border-gray-300 font-customFont">
          <div className="flex items-center justify-between">
          <div className="flex items-center flex-1 min-w-0">
            {/* Avatar */}
            <div className="relative">
              <div className="w-8 h-8 bg-gradient-to-br from-blue-500 to-blue-600 flex items-center justify-center rounded-full shadow-md">
                <span className="text-white font-bold text-sm">
                  {localStorage.getItem('name')
                    ? localStorage.getItem('name').charAt(0).toUpperCase()
                    : 'U'}
                </span>
              </div>
              {/* <div className="absolute -bottom-0.5 -right-0.5 w-3 h-3 bg-green-500 border-2 border-white rounded-full"></div> */}
            </div>
            {/* User Info */}
            <div className="ml-3 flex-1 min-w-0">
              <p className="font-semibold text-gray-800 capitalize truncate text-sm">
                {localStorage.getItem('name') || 'User Name'}
              </p>
              <p className="text-xs text-gray-500 truncate">
                {localStorage.getItem('email') || 'user@example.com'}
              </p>
            </div>
          </div>
          {/* Dropdown Arrow */}
          <div className="ml-2 flex items-center">
            <div
              className={`w-6 h-6 rounded-md bg-gray-100 group-hover:bg-gray-200 flex items-center justify-center transition-all duration-300 ${
                popoverVisible ? 'rotate-180' : ''
              }`}
            >
              <i className="fas fa-chevron-down text-gray-500 text-xs"></i>
            </div>
          </div>
          </div>
          </div>
      </Popover>
    </div>
  );
};

export default UserLoggedInUser;
